import { ArcadeLogo } from "@arcadeai/design-system/components/ui/atoms/icons/arcade-logo";
import type { JSX, ReactNode } from "react";
import {
  OnboardingSidebarRow,
  type OnboardingSidebarRowStatus,
} from "@/app/onboarding-first-win/components/onboarding-sidebar-row";

export type OnboardingSidebarStepDef = {
  icon: ReactNode;
  id: string;
  label: string;
  onClick?: () => void;
  recap?: ReactNode;
  status: OnboardingSidebarRowStatus;
};

type OnboardingSidebarProps = {
  footer?: ReactNode;
  steps: OnboardingSidebarStepDef[];
};

export function OnboardingSidebar({
  steps,
  footer,
}: OnboardingSidebarProps): JSX.Element {
  return (
    <nav className="flex h-full min-h-0 flex-1 flex-col px-8 pt-12 pb-4">
      <div className="flex h-7 shrink-0 items-center">
        <ArcadeLogo className="h-7 w-auto" />
      </div>

      <div className="flex min-h-0 flex-1 flex-col justify-start pt-[clamp(2.5rem,22vh,8rem)]">
        <ol className="flex w-full flex-col">
          {steps.map((step, index) => (
            <OnboardingSidebarRow
              icon={step.icon}
              id={step.id}
              isLast={index === steps.length - 1}
              key={step.id}
              label={step.label}
              onClick={step.onClick}
              recap={step.recap}
              status={step.status}
            />
          ))}
        </ol>
      </div>

      {footer && (
        <div className="flex w-full shrink-0 justify-start pt-6">{footer}</div>
      )}
    </nav>
  );
}
